import React, { useEffect, useState } from 'react';
import { CardHeader } from '@mui/material';
import { StyledCellLink, Weight } from '../Common/DataGrid/CellComponents';
import { getRangeFilterOperator } from '../Common/DataGrid/FilterComponents';
import { select_commonCellProps, text_commonCellProps } from '../Common/DataGrid/utils';
import {
    DataGrid,
    PageTitleWithToolTip
} from '../Common';
import Routes from '../../routes';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { TranslateW } from '../../Utils/Languages/Translate';

import { fetchFilterValues } from '../../utils';

const rangeFilterOperator = getRangeFilterOperator({});

const columns = [
    {
        field: 'assetName',
        headerName: 'System Name',
        ...text_commonCellProps,
        renderCell: ({ row: { assetName, assetID } }) => (
            <StyledCellLink
                path={`/Inventory/${assetID}`}
                text={assetName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'instanceAssociationName',
        headerName: 'Region',
        ...text_commonCellProps
    },
    {
        field: 'locationName',
        headerName: 'Location',
        ...select_commonCellProps,
        renderCell: ({ row: { locationName, locationID } }) => (
            <StyledCellLink
                path={`/Location/${locationID}`}
                text={locationName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'assetType',
        headerName: 'System Type',
        ...select_commonCellProps
    },
    {
        field: 'materialType',
        headerName: 'Material Type',
        ...select_commonCellProps
    },
    {
        field: 'gasCapacityLbs',
        headerName: 'Gas Capacity',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { gasCapacityLbs } }) => <Weight value={gasCapacityLbs} />
    },
    {
        field: 'currentGasWeightLbs',
        headerName: 'Current Gas Weight',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { currentGasWeightLbs } }) => <Weight value={currentGasWeightLbs} />
    }
]

const UnderRepairSystems = () => {

    const [filters, setFilters] = useState([]);

    const fetchFilters = async () => {
        const filters = await fetchFilterValues(Routes.Dashboard.UnderRepairSystemsDropdown());
        setFilters(filters);
    };

    useEffect(() => { fetchFilters() }, []);

    return (
        <div top-five-leak-rate-card>
            <DataGrid
                url={Routes.Dashboard.UnderRepairSystems(false)}
                exportButtonURL={Routes.Dashboard.UnderRepairSystems(true)}
                filterOptions={filters}
                columns={columns}
                rowCount="5"
                tableId={'under-repair-systems-table'}
                exportFileName={"Under Repair Systems"}
                exportButtonAlt={"Export Under Repair Systems (.csv)"}
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new asset or change your search criteria."
                headerContent={
                    <CardHeader
                        title={
                            <PageTitleWithToolTip
                                pageTitle="Under Repair Systems"
                                toolTipText="View active assets with a charge of at least 15 lbs that are currently in status Under Repair."
                            />
                        }
                        sx={{
                            "& .MuiCardHeader-action": { display: "flex" },
                            "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                        }}
                    />
                }
            />
        </div>
    );
}
export default UnderRepairSystems;
